<div class="mt-16 ttu title-s c-dark-grey" *ngIf="formattedPrice$ | async as formattedPrice">
    <span>{{ formattedPrice.primaryCurrency }} / {{ unitPrice.unit }}</span>
</div>
